import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { deleteInsumoComplete } from "../functions";

const StackInsumosDelete = ({ openDelete, setOpenDelete }) => {
  const dispatch = useDispatch();
  const { movementIdSelected } = useSelector(({ stackInsumos }) => stackInsumos);

  const handleDelete = async () => {
    await deleteInsumoComplete(movementIdSelected, dispatch);
    setOpenDelete(false);
  };

  return (
    <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
      <DialogTitle>
        <Typography variant="h6" sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#e11d48" }}>
          ¡Advertencia!
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontFamily: "'Poppins', sans-serif" }}>
          ¿Deseas eliminar este movimiento de inventario? Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDelete(false)} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          sx={{
            background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
            color: "#fff",
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 600,
            "&:hover": {
              background: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)",
            },
          }}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StackInsumosDelete;
